import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: 'amlCategoryTransformToRisk',
  standalone: true
})
export class AmlCategoryTransformToRiskPipe implements PipeTransform {
  transform(category: string): string {
    switch (category) {
      case 'atm':
        return 'medium';
      case 'bridge':
        return 'medium';
      case 'child abuse material':
        return 'severe';
      case 'custom address':
        return 'low';
      case 'darknet market':
        return 'severe';
      case 'decentralized exchange':
        return 'low';
      case 'exchange':
        return 'low';
      case 'fee':
        return 'low';
      case 'fraud shop':
        return 'severe';
      case 'gambling':
        return 'medium';
      case 'hosted wallet':
        return 'low';
      case 'illicit actor-org':
        return 'severe';
      case 'infrastructure as a service':
        return 'low';
      case 'lending':
        return 'low';
      case 'malware':
        return 'severe';
      case 'merchant services':
        return 'low';
      case 'mining':
        return 'low';
      case 'mining pool':
        return 'low';
      case 'mixing':
        return 'severe';
      case 'nft platform':
        return 'low';
      case 'nft platform - collection':
        return 'low';
      case 'no kyc exchange':
        return 'high';
      case 'online pharmacy':
        return 'severe';
      case 'other':
        return 'low';
      case 'p2p exchange':
        return 'low';
      case 'protocol privacy':
        return 'severe';
      case 'ransomware':
        return 'severe';
      case 'sanctioned entity':
        return 'severe';
      case 'sanctioned jurisdiction':
        return 'severe';
      case 'scam':
        return 'high';
      case 'seized funds':
        return 'high';
      case 'smart contract':
        return 'low';
      case 'special measures':
        return 'severe';
      case 'stolen funds':
        return 'severe';
      case 'terrorist financing':
        return 'severe';
      case 'token smart contract':
        return 'low';
      case 'unnamed service':
        return 'medium';
      case 'tracked to self':
        return 'low';
      case 'unspent':
        return 'low';
      default:
        return 'not_risk_status';
    }
  }
}
